import { BannerSlugEnum } from '@skippay/core/@types/bannerEnums';

import { BANNER_AVAILABLE_SLUGS } from 'constants/banners';

export interface BannerSlugState {
	hasActiveDeferredPayment: boolean;
	hasActivePayInThree: boolean;
	hasPreferredBank?: boolean;
}

const bannerActiveSlugs = ({
	hasActiveDeferredPayment,
	hasActivePayInThree,
	hasPreferredBank,
}: BannerSlugState): BannerSlugEnum[] => [
	hasActiveDeferredPayment
		? BannerSlugEnum.HAS_ACTIVE_DEFERRED_PAYMENT
		: BannerSlugEnum.HAS_NO_ACTIVE_DEFERRED_PAYMENT,
	hasActivePayInThree
		? BannerSlugEnum.HAS_ACTIVE_PAY_IN_THREE
		: BannerSlugEnum.HAS_NO_ACTIVE_PAY_IN_THREE,
	...(hasActiveDeferredPayment && hasActivePayInThree
		? [BannerSlugEnum.HAS_ACTIVE_DEFERRED_AND_PAY_IN_THREE]
		: []),
	...(!hasActiveDeferredPayment && !hasActivePayInThree
		? [BannerSlugEnum.HAS_NO_ACTIVE_DEFERRED_AND_PAY_IN_THREE]
		: []),
	...(hasPreferredBank === undefined
		? []
		: [
				hasPreferredBank ? BannerSlugEnum.HAS_PREFERRED_BANK : BannerSlugEnum.HAS_NO_PREFERRED_BANK,
			]),
];

export const bannerSlugsToExclude = (state: BannerSlugState): BannerSlugEnum[] => {
	const active = bannerActiveSlugs(state);
	return BANNER_AVAILABLE_SLUGS.filter((slug) => !active.includes(slug));
};
